import { Tea } from '@features/libs/tea';

export const reportLearnMoreClickEvent = (moduleName: string | undefined) => {
  Tea('button_click', {
    page_name: 'seller_university_homepage',
    tab_name: 'home_config_module_entrance',
    click_for: 'learn_more',
    module_name: moduleName,
  });
};

export const reportModuleContentClickEvent = (
  moduleName: string | undefined,
  contentId: string,
  index: string,
) => {
  Tea('button_click', {
    page_name: 'seller_university_homepage',
    tab_name: 'home_config_module_entrance',
    click_for: 'content',
    module_name: moduleName,
    content_id: contentId,
    index: index,
  });
};
